export const GET_ALL_PLACES_REQUEST = 'GET_ALL_PLACES_REQUEST';
export const GET_ALL_PLACES_SUCCESS = 'GET_ALL_PLACES_SUCCESS';
export const GET_ALL_PLACES_FAILURE = 'GET_ALL_PLACES_FAILURE';

export const GET_PLACE_BY_ID_REQUEST = 'GET_PLACE_BY_ID_REQUEST';
export const GET_PLACE_BY_ID_SUCCESS = 'GET_PLACE_BY_ID_SUCCESS';
export const GET_PLACE_BY_ID_FAILURE = 'GET_PLACE_BY_ID_FAILURE';

export const ADD_PLACE_REQUEST = 'ADD_PLACE_REQUEST';
export const ADD_PLACE_SUCCESS = 'ADD_PLACE_SUCCESS';
export const ADD_PLACE_FAILURE = 'ADD_PLACE_FAILURE';

export const UPDATE_PLACE_REQUEST = 'UPDATE_PLACE_REQUEST';
export const UPDATE_PLACE_SUCCESS = 'UPDATE_PLACE_SUCCESS';
export const UPDATE_PLACE_FAILURE = 'UPDATE_PLACE_FAILURE';

export const UPDATE_PLACE_STATUS_REQUEST = 'UPDATE_PLACE_STATUS_REQUEST';
export const UPDATE_PLACE_STATUS_SUCCESS = 'UPDATE_PLACE_STATUS_SUCCESS';
export const UPDATE_PLACE_STATUS_FAILURE = 'UPDATE_PLACE_STATUS_FAILURE';
